import { Banner } from "@/components/banner";
import { SNS } from "@/components/sns";
import { AsideBanner, DateSearchBar, RoomDetail, RoomFeed, RoomPreview, RoomPrices } from "@/domains/components";
import { useBookingRecoilValue } from "@/shared/client";
import { useGetRoom, type RoomBaseInfoResponse } from "@/shared/server";
import { getDefaultParameters } from "@/utils";
import { Box, Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

export const Rooms = () => {
    const { roomIdx } = useParams<string>();
    const option = { enabled: !!roomIdx };

    const { data } = useGetRoom<RoomBaseInfoResponse>({ roomIdx: roomIdx ?? "" }, option);
    const bookingEngine = useBookingRecoilValue();

    const { idx } = getDefaultParameters();

    if (!roomIdx) {
        // 404로 요청
        return <div>404로 요청합니다</div>;
    }

    return data ? (
        <Box w="100%">
            {idx === "2017" && <SNS />}
            <Box position="relative">
                <Banner imgList={data.imgList} catchPraise={data.catchPraise} />
                {!bookingEngine.isGoogleBE && <DateSearchBar isSubMenu />}
            </Box>
            <RoomDetail roomIdx={roomIdx} />
            <RoomPrices roomIdx={roomIdx} />
            <RoomFeed roomIdx={roomIdx} pensionName={data.catchPraise.main.firstLine} />
            <AsideBanner isFullImg={false} />
            <RoomPreview />
        </Box>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
